import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { list as physiciansList } from '@/graph/physicians';
import SelectInput from '@/se/components/inputs/SelectInput';

interface PhysicianSpecialityAutocompleteProps {
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

const PhysicianSpecialityAutocomplete: React.FC<PhysicianSpecialityAutocompleteProps> = ({
  value = '',
  onChange,
  label = 'Speciality',
  placeholder,
  required,
}) => {
  const { data } = useQuery(physiciansList);

  const options = useMemo(() => {
    const raw = (data?.physicians ?? []) as Array<{ speciality?: string | null }>;

    const map = raw.reduce<Record<string, string>>((acc, { speciality }) => {
      const trimmed = (speciality ?? '').trim();
      if (trimmed.length > 0) {
        acc[trimmed] = trimmed;
      }
      return acc;
    }, {});

    return map;
  }, [data]);

  return (
    <SelectInput
      name={label}
      options={options}
      value={value || ''}
      onChange={(val: string) => onChange?.(val)}
      placeholder={placeholder || label}
      isSearchable
      sortOptions
      menuWidthFollowContent={false}
      required={required}
    />
  );
};

export default PhysicianSpecialityAutocomplete;
